// src/pages/Users/Produits/components/VKardLink.jsx

import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";

export default function VKardLink({
  url = "https://profile.vkard.io/8f8e4d95-cf28-40b0-afc6-2ec677889d49/ab099714aa",
  logo = "https://media.licdn.com/dms/image/v2/D4E0BAQETJ3lAsk4sKA/company-logo_200_200/company-logo_200_200/0/1716333982627/vkard_io_logo?e=2147483647&v=beta&t=0mcqCmpMvHUPuoWJ5UFSid1as0YzDhH2ital1cterIg",
  label = "Ma VKard",
}) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      title="Ouvrir ma carte de visite VKard"
      className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-slate-100 px-4 text-sm font-bold text-slate-700 transition hover:bg-slate-200 active:scale-95 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
    >
      <img
        src={logo}
        alt="VKard"
        width={28}
        height={28}
        className="h-7 w-7 rounded-md object-contain"
        loading="lazy"
      />
      <span>{label}</span>
      <FaExternalLinkAlt className="text-xs opacity-70" />
    </a>
  );
}